module.exports = __webpack_public_path__ + "img/step2_zh-HK.26f25b68.png";